// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"389":"81ce8c75","880":"d408c330"}[chunkId] || chunkId) + "." + {"55":"313e62bc7e7dfb64","61":"b7dfbb3566d26549","295":"eb896eca93c0904a","389":"ac548f8ac0bd45ab","573":"0bca4e3a3acee2b9","877":"240cfda571dfb1c0","880":"168c9bcc88ed4874"}[chunkId] + ".js";
};